import type { FitBoundsMode } from '@/components/shipment/form/domain/map-paint-types';

export type MapCameraIntent =
  | { kind: 'bootstrapOverview' }
  | { kind: 'focusStop'; index: number }
  | { kind: 'routeOverview' };

export function bootstrapOverviewIntent(): MapCameraIntent {
  return { kind: 'bootstrapOverview' };
}

export function focusStopIntent(index: number): MapCameraIntent {
  return { kind: 'focusStop', index };
}

export function routeOverviewIntent(): MapCameraIntent {
  return { kind: 'routeOverview' };
}

export function resolveFitModeForIntent(
  fitMode: FitBoundsMode,
  options: {
    mapReady: boolean;
    bootstrapComplete: boolean;
    mapBootstrapMode: boolean;
    cameraEnabled: boolean;
  },
): FitBoundsMode {
  if (fitMode === false) return false;
  if (!options.mapReady) return false;

  if (fitMode === 'focus-stop') {
    return options.bootstrapComplete ? 'focus-stop' : false;
  }

  if (options.mapBootstrapMode && !options.bootstrapComplete) {
    return options.cameraEnabled ? 'full' : false;
  }
  if (options.mapBootstrapMode) {
    return options.cameraEnabled ? 'full' : false;
  }
  return 'full';
}
